const defaultState = {
  pieColors: [
    '#91C97E',
    '#75B1AC',
    '#6E81C0',
    '#905D9A',
    '#E77371',
    '#F7B467',
    '#FFF9A7',
  ],
}

const state = {...defaultState}

const mutations = {}
const actions = {}
const getters = {
  pieColors: state => state.pieColors,
  roundingMethod: state => {
    // TODO: 設定で切り替えれるようにする
    return Math.floor
  },
  roundingFunction: (state, getters) => {
    const method = getters.roundingMethod
    return function (val) {
      return method(val)
    }
  },
  roundingRatioFunction: (state, getters) => {
    const digit = 2
    const method = getters.roundingMethod
    return function (val) {
      return method(val * Math.pow(10, digit)) / Math.pow(10, digit)
    }
  },
  ratioStrFunction: (state, getters) => {
    // 小数点第n位までの表示を%表記で行うメソッド
    // 第n位の指定はdecimalpoint (今はひとまず2固定, のちに設定で変更できるように修正)
    // 0の場合は 0.00% のようにする
    // toFixedをつけると第n位までの表示はできるが，n+1の位で強制的に四捨五入されるので
    // さきにn+1位を指定の方法で丸める． 現状は切り捨て固定．
    const decimalPoint = 2
    const digit = decimalPoint + 2
    const method = getters.roundingMethod
    return function (val) {
      if (isNaN(val)) {
        return '-'
      }
      const tmp = (method(val * Math.pow(10, digit)) / Math.pow(10, digit - 2)).toFixed(decimalPoint)
      return tmp + '%'
    }
  },
}

export default {
  state,
  actions,
  getters,
  mutations,
  namespaced: true,
}



// WEBPACK FOOTER //
// ./src/store/modules/report.js